import initialState from './PlayersInitialState';
import reducers from './PlayersReducer';

export default {
  initialState,
  reducers,
};
